<template>
  <span class="tooltip-wrapper" tabindex="-1" @blur="displayTip = false">
    <span class="inline-block" @mouseenter="toggleTip" @mouseleave="toggleTip"
      ><svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.99998 0.240112C2.81818 0.240112 0.23938 2.81891 0.23938 6.00011C0.239301 6.75663 0.38825 7.50575 0.677719 8.20469C0.967188 8.90364 1.39151 9.53871 1.92644 10.0736C2.46138 10.6086 3.09646 11.0329 3.7954 11.3224C4.49434 11.6118 5.24346 11.7608 5.99998 11.7607C9.18058 11.7607 11.76 9.18191 11.76 6.00011C11.76 2.81891 9.18058 0.240112 5.99998 0.240112ZM6.53758 2.31971C7.09918 2.31971 7.26418 2.64551 7.26418 3.01811C7.26418 3.48311 6.89218 3.91331 6.25678 3.91331C5.72518 3.91331 5.47198 3.64631 5.48758 3.20411C5.48758 2.83151 5.79898 2.31971 6.53758 2.31971ZM5.09878 9.45011C4.71478 9.45011 4.43458 9.21671 4.70278 8.19371L5.14258 6.37871C5.21878 6.08831 5.23138 5.97191 5.14258 5.97191C5.02798 5.97191 4.52938 6.17231 4.23538 6.37031L4.04398 6.05651C4.97698 5.27711 6.04978 4.81991 6.50878 4.81991C6.89278 4.81991 6.95638 5.27351 6.76498 5.97191L6.26098 7.87991C6.17158 8.21711 6.20998 8.33351 6.29938 8.33351C6.41458 8.33351 6.79138 8.19431 7.16218 7.90211L7.37938 8.19371C6.47158 9.10091 5.48218 9.45011 5.09878 9.45011Z"
          fill="#7996B9"
        />
      </svg>
    </span>

    <div class="tooltip-info" v-if="displayTip">
      <p class="">{{ text }}</p>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    text: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      displayTip: false,
    };
  },
  methods: {
    toggleTip() {
      this.displayTip = !this.displayTip;
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}
.tooltip-info {
  position: absolute;

  color: white;
  background: var(--primaryblue);
  width: 12rem;
  padding: 0.5rem;
  z-index: 999;
  border-radius: 0.25rem;
  p {
    font-size: 0.7rem;
  }
}
</style>
